<template>
  <CHeader fixed with-subheader light>
    <CToggler in-header class="ml-3 d-lg-none" @click="toggleSidebarMobile" />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="toggleSidebarDesktop"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <span class="logo-text">Fabbi ECS</span>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!--      <CHeaderNavItem class="px-3">-->
      <!--        <CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink>-->
      <!--      </CHeaderNavItem>-->
    </CHeaderNav>
    <CHeaderNav class="mr-md-4 change-language-mobile">
      <select
        v-model="localeSelect"
        class="form-control"
        @change="changeLanguage($event)"
      >
        <option
          v-for="(locale, key) in locales"
          :value="locale.text"
          :key="key"
          >{{ $t(`locale.${locale.text}`) }}</option
        >
      </select>
      <TheHeaderDropdownAccnt
        :avatar="account.image_url"
        @handleLogout="logoutHandler"
        @handleRefreshToken="refeshTokenHanler"
      />
    </CHeaderNav>
    <CSubheader class="px-3">
      <Breadcrumb />
    </CSubheader>
  </CHeader>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { loadMessages } from "../plugins/i18n";
import { loadVeeValidate } from "@/plugins/vee-validate";
import Breadcrumb from "@/components/Common/Breadcrumb";

export default {
  name: "Header",
  components: {
    TheHeaderDropdownAccnt,
    Breadcrumb
  },
  data() {
    return {
      locales: [
        {
          text: "ja"
        },
        {
          text: "en"
        },
        {
          text: "vi"
        }
      ],
      fullPath: "",
      keyword: "",
      localeSelect: ""
    };
  },
  methods: {
    ...mapActions("layout", ["toggleSidebarMobile", "toggleSidebarDesktop"]),

    ...mapActions("auth", ["logout", "refreshToken"]),

    async logoutHandler() {
      await this.logout().then(() => {
        this.$router.push({ name: "Login" });
      });
    },

    async refeshTokenHanler() {
      await this.refreshToken();
    },

    changeLanguage(event) {
      let locale = event.target.value;
      if (this.$i18n.locale !== locale) {
        this.localeSelect = locale;
        loadMessages(locale);
        loadVeeValidate(locale);
        this.$store.dispatch("lang/setLocale", { locale });
      }
    }
  },
  computed: {
    ...mapState("lang", {
      locale: state => {
        return state.locale;
      }
    }),
    ...mapGetters({
      account: "auth/account"
    })
  },
  created() {
    this.localeSelect = this.$i18n.locale;
  }
};
</script>

<style lang="scss">
.c-header-brand {
  text-decoration: none !important;
}

span.logo-text {
  font-size: 20px;
}

.box-language {
  padding: 0 10px;
  margin-bottom: 0;
}
@media only screen and (max-device-width: 480px) {
  button.ml-3.d-lg-none.c-header-toggler {
    margin-left: 0 !important;
  }
  span.logo-text {
    font-size: 0.8125rem;
  }
}

@media only screen and (max-width: 767px) {
  .toast {
    width: 100% !important;
  }
}
</style>
